<script setup lang="ts">
import { PricingTable } from '~/src/widgets/pricing-table';
import { type ProductInfo, apiGetProduct, apiGetProductPrice } from '~/src/entities/product';

interface PricingTableProductIDs {
  productID: string;
  monthlyPriceID: string;
  annualPriceID: string;
}

const products = ref<ProductInfo[]>([]);

const productsIDs: PricingTableProductIDs[] = [
  {
    productID: 'prod_PfzluXlhbed9Zj',
    monthlyPriceID: 'price_1OtcTzF0nDiPh9l68G9nF1U2',
    annualPriceID: 'price_1OtcWhF0nDiPh9l6p8CPam5W',
  },
  {
    productID: 'prod_PfzlAkMc4X9yEw',
    monthlyPriceID: 'price_1OvS1jF0nDiPh9l6nUiLO2TW',
    annualPriceID: 'price_1OvS4GF0nDiPh9l6SvhEOEDR',
  },
  {
    productID: 'prod_Pfzl2PyVwebGCF',
    monthlyPriceID: 'price_1OvS7qF0nDiPh9l6P8XXZLV8',
    annualPriceID: 'price_1OvS9RF0nDiPh9l6HMOogDFr',
  },
];

function getProductWithPrice(prod: PricingTableProductIDs) {
  return Promise.all([
    apiGetProduct(prod.productID),
    apiGetProductPrice(prod.monthlyPriceID),
    apiGetProductPrice(prod.annualPriceID),
  ]);
}

const { data: productsData } = await useAsyncData('products', async () => {
  const [product_1, product_2, product_3] = await Promise.all([getProductWithPrice(productsIDs[0]), getProductWithPrice(productsIDs[1]), getProductWithPrice(productsIDs[2])]);
  return [product_1, product_2, product_3];
});

productsData.value?.forEach((prod) => {
  products.value.push({
    product: prod[0],
    monthlyPrice: prod[1],
    annualPrice: prod[2],
  });
});
</script>

<template>
  <PricingTable :products="products" />
</template>
